import { get, set } from '@ember/object';
import Component from '@glimmer/component';

import { t } from 'ember-intl';
import PowerSelect from 'ember-power-select/components/power-select';
import { not } from 'ember-truth-helpers';

export default class UiFormFieldSelectRecordComponent extends Component {
  // Getter and setter
  get labelProperty() {
    return this.args.labelProperty ?? 'label';
  }

  get searchField() {
    return this.args.searchField ?? 'label';
  }

  get selected() {
    if (this.args.selected) {
      return this.args.selected;
    }

    if (!this.selectPath) {
      return this.args.value ?? [];
    }

    return this.args.value?.map((value) => {
      return (
        this.args.options.find((option) => {
          return option[this.selectPath] === value;
        }) ?? {
          [this.labelProperty]: `${value[this.labelProperty]} (Invalid!)`,
        }
      );
    });
  }

  get selectPath() {
    return this.args.selectPath ?? 'value';
  }

  // Actions
  onChange = (records) => {
    if (this.args.onChange) {
      return this.args.onChange(records);
    }

    let newProperty = records.map((record) =>
      this.selectPath ? record[this.selectPath] : record,
    );

    set(this.args.model, this.args.property, newProperty);

    this.args.onShowValidations();
  };

  // Template
  <template>
    <PowerSelect
      @multiple={{true}}
      @allowClear={{not @isRequired}}
      @disabled={{@isDisabled}}
      @loadingMessage={{t 'ui.form.field.select.loading_message'}}
      @onChange={{this.onChange}}
      @options={{@options}}
      @placeholder={{@placeholder}}
      @renderInPlace={{@renderInPlace}}
      @search={{@onSearch}}
      @searchEnabled={{@isSearchEnabled}}
      @searchField={{this.searchField}}
      @searchMessage={{t 'ui.form.field.select.search_message'}}
      @searchPlaceholder={{t 'ui.form.field.select.search_placeholder'}}
      @selected={{this.selected}}
      as |option|
    >
      {{#if (has-block)}}
        {{yield option this.labelProperty}}
      {{else}}
        {{get option this.labelProperty}}
      {{/if}}
    </PowerSelect>
  </template>
}
